export function jsonSerialize (json) {
	return Object.keys(json).map(function (key) {
		return encodeURIComponent(key) + '=' +
			encodeURIComponent(json[key]);
	}).join('&');
}

export function replaceAll (string = '', mapObject) {
	for (const key in mapObject) {
		let re = new RegExp(key, 'gi');
		string = string.replace(re, mapObject[key]);
	}
	return string;
}
